import { render } from "./PatientShortCard.vue?vue&type=template&id=b9bc5da6&scoped=true"
import script from "./PatientShortCard.vue?vue&type=script&lang=js"
export * from "./PatientShortCard.vue?vue&type=script&lang=js"

import "./PatientShortCard.vue?vue&type=style&index=0&id=b9bc5da6&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9bc5da6"]])

export default __exports__